import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom'
import { getMovieDetails, getTvShowDetails, getImageUrl } from '../../services/tmdbApi/index';
import reviews from '../../data/reviews';
import './style.css'
import Spinner from '../../components/Spinner';
import ErrorMessage from '../../components/ErrorMessage';

const ReviewPage = () => {
	const { id, mediaType } = useParams(); // Get 'id' and 'mediaType' (movie/tv) from the URL
	const [details, setDetails] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	const itemReviews = reviews.find(
		(r) => r.id === parseInt(id) && r.mediaType === mediaType
	)
	console.log('Found Personal Review:', itemReviews);

	console.log('ReviewPage Loaded. ID:', id, 'MediaType:', mediaType);

	useEffect(() => {
		const fetchDetails = async () => {
			try {
				let data;
				if (mediaType === 'movie') {
					data = await getMovieDetails(id);
				} else if (mediaType === 'tv') {
					data = await getTvShowDetails(id);
				} else {
					setError('Invalid media type provided in the URL.');
					setLoading(false);
					return;
				}

				console.log('API Response Data:', data);

				if (data) {
					setDetails(data);
				} else {
					setError('Could not fetch details. Item might not exist or API error.');
				}
			} catch (err) {
				console.error('Error fetching details:', err);
				setError('An error occurred while fetching details. Please try again later.');
			} finally {
				setLoading(false);
			}
		};

		fetchDetails();
	}, [id, mediaType]); // Re-run effect if ID or mediaType changes

	console.log('Current details state:', details);
	console.log('Current loading state:', loading);
	console.log('Current error state:', error);

	if (loading) {
		return (
			<div className='review-page-container'>
				<Spinner />
				<p>Loading...</p>
			</div>
		);
	}

	if (error) {
		return (
			<div className='review-page-container'>
				<ErrorMessage message={error} />
				<p>Loading...</p>
			</div>
		);
	}

	if (!details) {
		return <div className="review-no-review-message">No details found for this item.</div>;
	}

	// Determine title and release date based on media type
	const title = details.title || details.name;
	const releaseDate = details.release_date || details.first_air_date;

	return (
	<div className="review-page-container"> {/* Use class */}
		<div className="review-header"> {/* Use class */}
		{details.poster_path ? (
			<img
			src={getImageUrl(details.poster_path, 'w500')}
			alt={title}
			className="review-poster" // Use class
			/>
		) : (
			<div className="review-no-poster">No Image Available</div>
		)}
		<div className="review-info"> {/* Use class */}
			<h1 className="review-title">{title}</h1> {/* Use class */}
			{details.tagline && <p className="review-tagline">{details.tagline}</p>} 
			<ul className="review-genre-list"> {/* Use class */}
			{details.genres && details.genres.map(genre => (
				<li key={genre.id} className="review-genre-item">{genre.name}</li> 
			))}
			</ul>
			<p className="review-overview">{details.overview}</p>
			<ul className="review-details-list">
			{releaseDate && (
				<li className="review-detail-item">
				<span className="review-detail-label">Release Date:</span> {releaseDate}
				</li>
			)}
			{details.runtime && mediaType === 'movie' && (
				<li className="review-detail-item">
				<span className="review-detail-label">Runtime:</span> {details.runtime} mins
				</li>
			)}
			{details.number_of_seasons && mediaType === 'tv' && (
				<li className="review-detail-item">
				<span className="review-detail-label">Seasons:</span> {details.number_of_seasons}
				</li>
			)}
			{details.vote_average && (
				<li className="review-detail-item">
				<span className="review-detail-label">TMDb Rating:</span> {details.vote_average.toFixed(1)}/10
				</li>
			)}
			</ul>
		</div>
		</div>

		<div className="your-review-section"> {/* This class is from original inline styles */}
			<h2 className="review-section-heading">Our Personal Reviews</h2>
			{itemReviews && itemReviews.reviews && itemReviews.reviews.length > 0 ? (
				itemReviews.reviews.map((rev, index) => (
					<div key={index} className="review-content">
						<h3 className="reviewer-name">{rev.reviewer}</h3>

						<p className="review-meta">
							<strong>Rating:</strong> {rev.rating}
							{rev.reviewDate && <span> • Reviewed on: {rev.reviewDate}</span>}
						</p>

						<p
							className="review-text"
							dangerouslySetInnerHTML={{
							__html: rev.reviewText.trim().replace(/\n/g, "<br />"),
							}}
						/>
					</div>
				))
			) : (
				<div className="review-no-review-message">
					<p>No personal reviews available for <strong>{title}</strong> yet.</p>
				</div>
			)}
		</div>
	</div>
	);
}

export default ReviewPage;